const useGetRoles = () => {
  const userInfoString = JSON.parse(localStorage.getItem("userInfo"));

  const role = userInfoString?.userRole;

  return role;
};
export default useGetRoles;
